import { Button, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const TaxExemption: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();

  return (
    <Grid container padding={1} spacing={2}>
      <Grid item xs={12}> 
        <Typography>Exempt Tax of all item or selected item.</Typography>
        <Divider sx={{ mt: 1, mb: 2 }} /> {/* Divider with spacing around it */}
      </Grid>

      <Grid item xs={12} sm={6}>
      <WSSCheckBoxField
              id="tax1"
              name="tax1"
              label="Tax 1"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
      </Grid>

      <Grid item xs={12} sm={6}>
      <WSSCheckBoxField
              id="tax2"
              name="tax2"
              label="Tax 2"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
      </Grid>

      <Grid item xs={12} sm={6}>
      <WSSCheckBoxField
              id="tax3"
              name="tax3"
              label="Tax 3"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
      </Grid>

      <Grid item xs={12} sm={6}>
      <WSSCheckBoxField
              id="tax4"
              name="tax4"
              label=""
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
      </Grid>

      {/* Button in the right corner */}
      <Grid item xs={12}>
        <Grid container justifyContent="flex-end" gap={2}>
        <Button variant="outlined" >
            Apply All
          </Button>
          <Button variant="outlined" >
            Apply Selected
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
